<template>
  <yv-form-search
    :formSearch="baseFormSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  >
    <template #search-actions="{ actions }">
      <md-button
        native-type="submit"
        @click.native.prevent="actions.search"
        class="md-info md-round"
        >{{ $t("common.report") }}
      </md-button>
    </template>
  </yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import {
  filterOptions as filterOptionsMixin,
  baseFormSearch as baseFormSearchMixin
} from "../mixins";
import { Message } from "@/helpers/utils";

export default {
  components: { YvFormSearch },
  mixins: [filterOptionsMixin, baseFormSearchMixin],
  methods: {
    search(queryParams) {
      if (this.hasNoTerm) {
        Message.error("Please select term to view report");
        return;
      }
      this.$emit("fetch-report", queryParams);
    }
  },
  watch: {
    defaultClasses() {
      if (this.hasNoTerm) {
        return;
      }
      // fetch with all classes
      this.$emit("fetch-report", {
        term_id: this.termId
      });
    }
  },
  computed: {
    hasNoTerm() {
      return !this.baseFormSearch[0].value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
